import { generatePath } from "react-router-dom";
export const getPath = (path) => {
    const pushPath = (params = {}) => generatePath(`${process.env.API_URL || ""}${path}`, params);
    return { path, pushPath };
};
